import React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import { resetPassword } from 'store/userReducer';
import ResetPasswordForm from './ResetPasswordForm';

export const links = [
  <Link to="/login">Login</Link>
];

class ResetPasswordContainer extends React.Component {
  render() {
    return (
      <ResetPasswordForm onSubmit={this.props.handleSubmit} />
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { token, id } = queryString.parse(ownProps.location.search);
  const { history } = ownProps;

  return {
    handleSubmit: (values) =>
      dispatch(resetPassword([
        Object.assign(values, { token, id }),
        () => history.push('/login'),
      ]))
  }
};

export default connect(null, mapDispatchToProps)(ResetPasswordContainer);



// WEBPACK FOOTER //
// ./src/features/user/ResetPasswordContainer/ResetPasswordContainer.js